export default __webpack_public_path__ + "static/media/ggmap.15c65679.png";